import { ModalPortal, PrimaryButton } from '@movingimage-evp/mi-ui-component-library';
import DOMPurify from 'dompurify';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './terms-and-conditions-modal.module.css';

type TermsAndConditionsModalProps = {
  header?: string | null;
  subheader?: string | null;
  content: string;
  language: string;
  onAcceptClick: () => void;
};

export function TermsAndConditionsModal(props: TermsAndConditionsModalProps) {
  const { header, subheader, content, language } = props;

  const { t } = useTranslation('translations', { lng: language });

  const [isOpen, setIsOpen] = useState(true);

  const handleOnAcceptClick = () => {
    setIsOpen(false);
    props.onAcceptClick();
  };

  return (
    <ModalPortal isOpen={isOpen}>
      <div data-testid="terms-and-conditions-modal" className={styles.termsAndConditionsModal}>
        <div className={styles.termsAndConditionsModalContentWrapper}>
          {header && <h1 data-testid="terms-and-conditions-header">{header}</h1>}
          {subheader && <h2 data-testid="terms-and-conditions-subheader">{subheader}</h2>}
          <div className={styles.termsAndConditionsModalBody}>
            <div
              data-testid="terms-and-conditions-content"
              className={styles.termsAndConditionsModalContent}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content, { ADD_ATTR: ['target'] }) }}
            />
          </div>
          <PrimaryButton
            data-testid="terms-and-conditions-accept-button"
            className={styles.closeButton}
            small
            onClick={handleOnAcceptClick}
          >
            {t('common.termsAndConditions.acceptLabel')}
          </PrimaryButton>
        </div>
      </div>
    </ModalPortal>
  );
}
